import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { AgentChart } from '../../../hooks/EdisonAgent';

interface Props {
    result: AgentChart;
}

const AgentVegaChart: React.FC<Props> = ({ result }) => {
    const chartRef = useRef<HTMLDivElement>(null);

    // Merge data into spec if provided separately
    const spec = result.data ? { ...result.spec, data: { values: result.data } } : result.spec;

    useEffect(() => {
        const embedChart = async () => {
            if (chartRef.current) {
                try {
                    // Clear any existing chart
                    chartRef.current.innerHTML = '';

                    let finalSpec = spec;
                    if (typeof spec === 'string') {
                        // console.error('Chart spec is a string, not an object. Parsing it now.');
                        try {
                            finalSpec = JSON.parse(spec);
                        } catch (parseErr) {
                            console.error('Failed to parse spec string:', parseErr);
                            return;
                        }
                    }

                    // Dynamically import vega-embed
                    // @ts-ignore - moduleResolution issue with vega-embed types
                    const vegaEmbed = await import('vega-embed');

                    // Pass the spec as-is, never stringify it
                    await vegaEmbed.default(chartRef.current, finalSpec, {
                        actions: false,
                        renderer: 'svg',
                        config: {
                            view: {
                                continuousWidth: 400,
                                continuousHeight: 300,
                            },
                        },
                    });
                } catch (err) {
                    console.error('Failed to embed Vega chart:', err);
                }
            }
        };
        embedChart();

        // Cleanup function
        return () => {
            if (chartRef.current) {
                chartRef.current.innerHTML = '';
            }
        };
    }, [spec]);

    return (
        <Box sx={{ mb: 2 }}>
            {result.title && (
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    {result.title}
                </Typography>
            )}
            <div ref={chartRef} style={{ width: '100%' }} />
        </Box>
    );
};

export default AgentVegaChart;
